module.exports = __webpack_public_path__ + "img/logoBar.440ec188.png";